import { Card } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const SuccessTaxpayerRequest = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const messageTitle = t('taxpayer-request.messages.successRegistrationTaxpayerTitle');
  const messageSubTitle = t('taxpayer-request.messages.successRegistrationTaxpayerSubTitle');
  const closeText = t('taxpayer-request.label.close');

  return (
    <Card>
      <Card.Body>
        <div className="align-items-center">
          <div className="d-flex justify-content-center">
            <Icon.Check2Circle size={130} color="green" />
          </div>
          <div className="mt-2 d-flex justify-content-center">
            <h3>{messageTitle}</h3>
          </div>
          <div className="d-flex justify-content-center">{messageSubTitle}.</div>

          <div className="d-flex justify-content-center mt-3">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate('/');
              }}
            >
              {closeText}
            </a>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};
